import { FormControlLabel } from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import RadioButton from "../radio";

// Fix radio button
const LocationCard = ({
  station = {
    name: "ШТС-2",
    location: "Хан-уул дүүрэг, 15-р хороо, APU барилга",
  },
  isBtnRight = true,
  selected,
  setSelected,
}) => {
  return (
    <div>
      <div
        className={`d-flex gap-0 ${
          isBtnRight ? "px-4 justify-content-between" : ""
        } `}
        onClick={() => setSelected(station)}
      >
        <div
          className={`d-flex flex-column mt-3 ${
            isBtnRight ? "order-1" : "order-2"
          }`}
        >
          <h2 className="font-size-14 font-weight-bold mb-1">{station.name}</h2>
          <div className="font-size-14 text-grey font-weight-light mb-3">
            {station.location}
          </div>
          <div className="d-flex">
            <a className="text-grey">
              {station?.available_gases?.map((value, index) => (
                <span key={index} className="text-bg-dark-blue">
                  {value} - ₮4’200
                </span>
              ))}
            </a>
          </div>
        </div>
        <FormControlLabel
          className={`my-4 ${isBtnRight ? "" : "mx-4"} order-1`}
          value={selected}
          control={
            <RadioButton
              checked={station === selected}
              checkedcolor={`${station === selected ? "#F26422" : "#02172F"}`}
            />
          }
        />
      </div>
      <div className="divider mt-3" />
    </div>
  );
};

export default LocationCard;
